import {type Counter} from './Counter'

/** Отправить счетчик с временной меткой. */
export function sendTimeMark(counterId: Counter): void {
  try {
    Ya.Rum.sendTimeMark(counterId)
  } catch (error) {
    console.error(error)
  }
}
